import { useState, useEffect } from 'react';

export const useIsPC = () => {
  const [ isPCView, setIsPCView ] = useState(false);
  const windowSize = useWindowSize();

  useEffect(() => {
    const pcView = windowSize.width > 768;
    setIsPCView(pcView);
  }, [windowSize]);

  return isPCView;
};

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};
